import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import base from "./plugins/axios";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import dayjs from "dayjs";

Vue.config.productionTip = false;
Vue.prototype.$http = base;

import VueHead from "vue-head";
Vue.use(VueHead);

import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: "UA-144114870-1",
  router
});

Vue.filter("datetimeFormatter", value => {
  return dayjs(value)
    .format("YYYY/MM/DD HH:mm:ss")
    .toString();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
